import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
query listProductGroups($filter: ProductGroupFilter) {
	cashAssist {
		listProductGroups(filter: $filter) {
			...productGroupMain
		}
	}
}
${main}`
